const breadCrumb = "Lançamento de Notas - Lançar Justificativas";

const routes = [
  {
    path: "/permitir-consultar-pendencias-de-lancamento-de-aspectos-socioafetivos",
    name: "permitir-consultar-pendencias-de-lancamento-de-aspectos-socioafetivos",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirConsultarPendenciasDeLancamentoDeAspectosSocioafetivos/PermitirConsultarPendenciasDeLancamentoDeAspectosSocioafetivosHome.vue"
      ),
  },
  {
    path: "/permitir-consultar-pendencias-de-lancamento-de-aspectos-socioafetivos/:id/detalhes",
    name: "permitir-consultar-pendencias-de-lancamento-de-aspectos-socioafetivos-detalhes",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirConsultarPendenciasDeLancamentoDeAspectosSocioafetivos/PendenciaDeAspectoSocioafetivosDetalhes.vue"
      ),
  },
  {
    path: "/permitir-consultar-pendencias-de-lancamento-de-aspectos-socioafetivos/:id/detalhes/:resumoAspectoId",
    name: "permitir-consultar-pendencias-de-lancamento-de-aspectos-socioafetivos-detalhes-aspecto",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/PermitirConsultarPendenciasDeLancamentoDeAspectosSocioafetivos/PendenciaDeAspectoSocioafetivosDetalhesDiario.vue"
      ),
  },
];

export default routes;
